import React from "react";
import ReactDOM from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import App from "./App";
import "./styles/cookyFonts.css";
import "./styles/app.scss";

/** Provided via environment configuration. */
const POSTHOG_PROJECT_TOKEN = import.meta.env.VITE_POSTHOG_KEY as string;
const POSTHOG_API_HOST = "https://us.i.posthog.com";

const posthogOptions = {
  api_host: POSTHOG_API_HOST,
  defaults: "2026-01-30" as const,
  capture_pageview: false,
};

/**
 * Initialize PostHog before React mounts so first-render captures (welcome step)
 * do not race against provider initialization and get dropped.
 */
if (!(posthog as { __loaded?: boolean }).__loaded) {
  posthog.init(POSTHOG_PROJECT_TOKEN, posthogOptions);
} else {
  posthog.set_config(posthogOptions);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
